import { SortingCriteria } from '@cinch-nx/data-search'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import { CarsCarousel } from '@cinch-nx/shared-cars-carousel'
import { useEffect } from 'react'
import { Tabs } from '../shared/tabs'

const tabButtonTrackingEvent = (tabOrderNumber: number) => ({
  eventName: `Tabbed Carousel Component`,
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      name: EventNames.click,
      category: 'New Users Tabbed Carousel Component',
      label: tabOrderNumber === 1 ? 'Used cars tab' : 'New cars tab',
      action: 'Tab Clicked',
    },
  },
})

export const NewAndUsedVehicles: React.FC = () => {
  const { trackEvent } = useAnalytics()

  useEffect(() => {
    /**
     * Work around as there is a race condition happening in the datalayer
     * which means that sometimes the track event fires before Adobe scripts
     * have loaded.
     */
    const timeoutId = setTimeout(() => {
      trackEvent({
        eventName: 'New user module',
        type: TrackingEventTypes.PAGE,
        data: {
          event: {
            category: 'new-user-module',
            label: 'new-user-tabbed-carousel-component',
            action: 'triggered',
            name: 'load',
          },
        },
      })
    }, 3000)
    return () => clearTimeout(timeoutId)
  }, [trackEvent])

  return (
    <Tabs
      ariaLabel="used-and-new-cars-list"
      tabs={[
        {
          label: 'Used cars',
          trackingEvent: tabButtonTrackingEvent(1),
          panelContent: (
            <CarsCarousel
              carsCondition="used"
              priceFrom={10_000}
              priceTo={20_000}
              sortBy={SortingCriteria.FIRST_PUBLISHED_DATE_DESC}
            />
          ),
        },
        {
          label: 'New cars',
          trackingEvent: tabButtonTrackingEvent(2),
          panelContent: (
            <CarsCarousel
              carsCondition="new"
              disclaimer="Sold by our partner Marshall Motor Group"
              sortBy={SortingCriteria.FIRST_PUBLISHED_DATE_DESC}
            />
          ),
        },
      ]}
    />
  )
}
